import { useEffect } from 'react';

import { type FooterState, updateFooter } from '@soluto-private/mx-app-footer';

export const useFooter = (props: FooterState = { show: true }) =>
  useEffect(() => {
    updateFooter(props);
  }, [props]);
